// DEPRECATED
import React from 'react';
import { useTranslation } from 'react-i18next';
import TextTooltipOnHover from '../../Popover/Preset/TextTooltipOnHover';
import LoadingIndicator from '../../LoadingIndicator';
import DSModal from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
const ModalFormDialog = ({ title , subtitle , children , headerExtras , footerExtras , className , isOpen , withCancelBtn =true , isLoading , cancelBtnLabel , submitBtnLabel , disabledSubmit , disabledCancel , submitTooltip , submitBiData , onSubmit , onCancel , onClose , showHeaderBorder , showFooterBorder , shouldCloseOnOverlayClick , bodyScrollLockOptions , useMobileFixedHeight  })=>{
    const { t  } = useTranslation();
    const renderFooter = ()=>{
        const submitButton = /*#__PURE__*/ React.createElement(BrandedButton, {
            key: "submit",
            size: "large",
            variant: "brand-green",
            onClick: onSubmit,
            disabled: disabledSubmit,
            biData: submitBiData
        }, submitBtnLabel || t('popup.confirm'));
        return [
            withCancelBtn && /*#__PURE__*/ React.createElement(TextButton, {
                onClick: onCancel || onClose,
                disabled: disabledCancel,
                size: "large",
                variant: "main"
            }, cancelBtnLabel || t('popup.cancel')),
            disabledSubmit && submitTooltip && /*#__PURE__*/ React.createElement(TextTooltipOnHover, {
                tooltipText: submitTooltip
            }, submitButton),
            !(disabledSubmit && submitTooltip) && submitButton
        ].filter((x)=>x);
    };
    return /*#__PURE__*/ React.createElement(DSModal, {
        className: className,
        isOpen: isOpen !== null && isOpen !== void 0 ? isOpen : false,
        heading: title,
        subheading: subtitle,
        footerLeft: [
            footerExtras
        ],
        footerRight: renderFooter(),
        preamble: headerExtras,
        onRequestClose: onClose,
        useFixedMobileHeight: useMobileFixedHeight,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        bodyScrollLockOptions: bodyScrollLockOptions,
        withScrollableContentWrapper: true,
        showHeaderBorder: showHeaderBorder,
        showFooterBorder: showFooterBorder
    }, children, isLoading && /*#__PURE__*/ React.createElement(LoadingIndicator, null));
};
ModalFormDialog.displayName = 'ModalFormDialog';
export default ModalFormDialog;
